import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const palette: Record<string, string> = {
  ovh: 'bg-[#123e74]/15 text-[#123e74] border-[#123e74]/30 dark:bg-[#123e74]/30 dark:text-blue-200',
  hostinger: 'bg-[#673de6]/15 text-[#673de6] border-[#673de6]/30 dark:bg-[#673de6]/30 dark:text-violet-200',
  planethoster: 'bg-pink-500/15 text-pink-700 border-pink-500/30 dark:text-pink-300',
  other: 'bg-muted text-muted-foreground',
};

export function HostBadge({ host }: { host?: string | null }) {
  const key = (host ?? 'other').toLowerCase();
  const cls = palette[key] ?? palette.other;
  const label = key === 'other' ? '—' : key.toUpperCase();
  return <Badge className={cn('uppercase tracking-wider text-[10px] font-bold border', cls)}>{label}</Badge>;
}
